import { render, staticRenderFns } from "./modelFive.vue?vue&type=template&id=64731728&scoped=true&"
import script from "./modelFive.vue?vue&type=script&lang=js&"
export * from "./modelFive.vue?vue&type=script&lang=js&"
import style0 from "./modelFive.vue?vue&type=style&index=0&id=64731728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64731728",
  null
  
)

export default component.exports